import { css } from "@emotion/core";

export const rteWrapperStyle = css`
  position: relative;
  border: 1px solid #eaeaea;
  border-radius: 5px;
`;

export const rteSuggestionsContainer = css`
    border: none;
    background: rgb(251, 251, 251);
    border-radius: 5px 5px 0px 0px;
    padding: 10px;
    display: flex;
`;

export const rteSuggestion = css`
    background: rgb(255, 255, 255);
    border: 1px solid rgb(215, 215, 215);
    border-radius: 5px;
    padding: 5px;
    font-size: 12px;
    margin: 0 5px;
    color: rgb(102, 102, 102);
    cursor: pointer;
`
